import { render, staticRenderFns } from "./ayden.vue?vue&type=template&id=42520f41&scoped=true"
import script from "./ayden.vue?vue&type=script&lang=js"
export * from "./ayden.vue?vue&type=script&lang=js"
import style0 from "./ayden.vue?vue&type=style&index=0&id=42520f41&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42520f41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/centurygame/web-vip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42520f41')) {
      api.createRecord('42520f41', component.options)
    } else {
      api.reload('42520f41', component.options)
    }
    module.hot.accept("./ayden.vue?vue&type=template&id=42520f41&scoped=true", function () {
      api.rerender('42520f41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ayden.vue"
export default component.exports